import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FormApi from '../../Api/FormApi';
import { useAppSelector } from '../../Reducers/store';
import { FormDto } from '../../Models/FormDto';
import { UserLevelNames } from '../../Models/UserLevel';

interface PendingFormsListProps {
  onHasFormsChange?: (hasForms: boolean) => void;
}

const PendingFormsList: React.FC<PendingFormsListProps> = ({
  onHasFormsChange,
}) => {
  const { userModel } = useAppSelector((state) => state.user);
  const [forms, setForms] = useState<FormDto[]>([]);
  const [availableFormsForUserIds, setAvailableFormsForUser] = useState<
    number[]
  >([]);

  const isRegistrar =
    userModel?.userLevelId === UserLevelNames.SuperAdmin ||
    userModel?.userLevelId === UserLevelNames.MemberAdmin;

  useEffect(() => {
    if (!userModel?.id) return;

    const fetchData = async () => {
      const [formsRes, submittedRes] = await Promise.all([
        FormApi.getAllForms(),
        FormApi.getSubmittedFormIdsByUser(userModel.id),
      ]);

      const allForms = formsRes.data;
      const availableFormIds = submittedRes.data;

      const activeUnsubmitted = allForms.filter(
        (form) =>
          form.isActive &&
          (!form.startDate || new Date(form.startDate) <= new Date()) &&
          (!form.endDate || new Date(form.endDate) >= new Date()) &&
          availableFormIds.includes(form.formId!)
      );

      setForms(activeUnsubmitted);
      setAvailableFormsForUser(availableFormIds);
      onHasFormsChange?.(activeUnsubmitted.length > 0);
    };

    fetchData();
  }, [userModel?.id, onHasFormsChange]);

  if (!userModel?.id) return null;

  return (
    <div className='p-4 border rounded shadow bg-white'>
      <h2 className='text-lg font-semibold mb-2'>
        {isRegistrar
          ? 'Active Forms (register yourself or others)'
          : 'Forms Pending Your Submission'}
      </h2>
      {isRegistrar && (
        <p className='text-sm text-gray-600 mb-2'>
          Member admins can open a form after submitting for themselves to
          register other people at the company.
        </p>
      )}
      {forms.length === 0 ? (
        <p>No active forms.</p>
      ) : (
        <ul className='space-y-2'>
          {forms.map((form) => (
            <li key={form.formId}>
              {availableFormsForUserIds.includes(form.formId!) == false ? (
                <span className='text-gray-500'>
                  {form.title} (Already Submitted)
                </span>
              ) : (
                <Link
                  to={`/forms/fill/${form.formId}`}
                  className='text-blue-600 hover:underline'
                >
                  {form.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PendingFormsList;
